import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useCaptcha() {
  const [captcha, setCaptcha] = useState(null);
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setAnswer("");
    try {
      const { data } = await api.get("/auth/captcha");
      setCaptcha(data);
    } catch {
      toast.error("Gagal memuat captcha. Coba muat ulang.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return {
    captcha, answer, setAnswer, refresh, loading,
    payload: { captcha_id: captcha?.captcha_id || "", captcha_answer: answer.trim() },
  };
}
